export const IDENTITY_LOADED_KEY = "sanctum.user.loaded";
